import { Link } from 'react-router-dom';
import { collections } from '@/mocks/content';
import SectionHeading from '@/components/feature/SectionHeading';

export default function HomeCollections() {
  return (
    <section className="w-full bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="Editor's Picks"
        title="精选专题推荐"
        description="结合当季热点与长期口碑，我们为你整理了几组值得一次性看完的片单。"
      />

      <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-3">
        {collections.map((collection) => (
          <Link
            key={collection.id}
            to="/movies"
            className="group relative block cursor-pointer overflow-hidden rounded-lg border border-background-200"
          >
            <div className="h-[220px] w-full overflow-hidden bg-background-300 md:h-[260px]">
              <img
                src={collection.image}
                alt={`${collection.title} 专题封面`}
                title={`${collection.title} 精选影视专题`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
              <span className="inline-block rounded-sm bg-accent-500 px-2 py-0.5 font-label text-[10px] font-bold tracking-wide text-foreground-950">
                {collection.count}
              </span>
              <h3 className="mt-2.5 font-heading text-base font-bold text-background-50 md:text-lg">
                {collection.title}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-background-200/85">
                {collection.subtitle}
              </p>
              <span className="mt-3 flex items-center gap-1 font-label text-[11px] font-semibold text-accent-300">
                查看专题
                <i className="ri-arrow-right-line text-[12px] transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}